export function isProductHomePath(
  path: string,
  simpleProductId?: string | null,
): boolean {
  if (!simpleProductId) return false

  const clean = path.split('?')[0].split('#')[0]
  const segments = clean.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean)

  // language-prefixed (e.g., /en/:simpleId) or plain (/:simpleId)
  const maybeLang = segments[0]
  const isLang = /^[a-z]{2}$/i.test(maybeLang) // keep in sync with your routing

  if (!isLang && segments.length === 1) {
    return segments[0] === simpleProductId
  }
  if (isLang && segments.length === 2) {
    return segments[1] === simpleProductId
  }
  return false
}
